import { FaMapMarkerAlt } from "react-icons/fa";
import { formatDate, formatFormValue } from "../../../services/format";
import { FormItemType } from "../../UI/view/component-map";
import { FormView } from "../../UI/view/form-view";
import { ListView, ListViewColumnType, initListView } from "../../UI/view/list-view";
import { initView } from "../../UI/view/view";
import { rareGasEditDataSource, rareGasSensorsDataSource } from "./raregas-ds";
import { LocationMapWrapper } from "../../UI/organisms/Sensors/location-map-wrapper";
import { convertToPreferred } from "../../../services/user-preferences";
import { elecontricsSensorsDataSource, electronicsDs } from "./electronics";
import { SensorChartWrapper } from "../../UI/organisms/Sensors/sensor-chart-wrapper";

export const ElectronicsSummaryTable = initListView({
  hideGlobalFilter: true,
  columns: [
    {
      Header: 'Location',
      accessor: 'location',
      disableSortBy: true,
      tooltip: (row) => `Value from: ${formatDate(row.ReadingDate)}`
    },
    {
      Header: 'Battery Voltage',
      accessor: 'batteryLevel',
      defaultSort: true,
      disableSortBy: true,
      tooltip: (row) => `Value from: ${formatDate(row.ReadingDate)}`
    },
    {
      Header: `Ambient Temperature (F)`,
      id: 'ambientTemperature',
      accessor: ({ ambientTemperature }) => {
        return ambientTemperature;
      },
      disableSortBy: true,
      tooltip: (row) => `Value from: ${formatDate(row.ReadingDate)}`
    },
    {
      Header: 'GPS',
      accessor: 'gps',
      disableSortBy: true,
      type: ListViewColumnType.link,
      linkPath: ({value, row}) => `https://www.google.com/maps/search/?api=1&query=${row.original.Latitude},${row.original.Longitude}`,
      icon: FaMapMarkerAlt

    },
  ]

} as ListView, electronicsDs, state => {
  const { myLoc, myBattV, myTemp } = state.electronicssensors?.current?.data || {};
  if (state.electronicssensors?.current?.data)
    return [
      {
        location: myLoc?.Location,
        batteryLevel: myBattV?.ReadingValue,
        ambientTemperature: myTemp?.ReadingValue,
        Latitude: myLoc?.Latitude,
        Longitude: myLoc?.Longitude,
        ReadingDate: myLoc?.ReadingDate,
      }
    ]
  return [];
})


export const getDefaultDateRange = () => {
  const d = new Date();
  d.setMonth(d.getMonth() - 6);

  return {
    start: d,
    end: new Date()
  }
}

export const ElectronicsSensorTab = initView({
  form: {
    editMode: true,
    items: [
      {
        type: FormItemType.fieldset,
        isFluid: true,
        label: 'Latest Readings',
        items: [
          {
            type: FormItemType.customComponent,
            component: ElectronicsSummaryTable
          }
        ]
      },
      {
        type: FormItemType.row,
        items: [
          {
            type: FormItemType.daterange,
            name: 'dateRange',
            defaultValue: getDefaultDateRange(),
            style: { marginLeft: 0, marginTop: 0 },
          },

        ]
      },
      {
        type: FormItemType.row,
        items: [
          {
            type: FormItemType.fieldset,
            label: 'Device Sensors',
            allowGrow: true,
            items: [
              {
                type: FormItemType.customComponent,
                component: SensorChartWrapper
              }
            ]
          },
          {
            type: FormItemType.fieldset,
            label: 'Map',
            allowGrow: true,
            items: [
              {
                type: FormItemType.customComponent,
                componentArgs: {
                  assetType: 'Electronics'
                },
                component: LocationMapWrapper
              }
            ]
          },
        ]
      }
    ]
  } as FormView, dataSource: elecontricsSensorsDataSource
});

export const electronicsEdit = {
  editMode: true,
  pageHeader: 'Electronics',
  breadcrumbs: [
    {
      name: 'Electronics',
      icon: 'currency-dollar',
      to: '/assets#Electronics',
    },
  ],
  items: [
    {
      type: FormItemType.masterDetailLayout,
      items: [
        {
          items: [
            {
              type: FormItemType.infoPane,
              header: ({ electronics }) => electronics?.current?.data?.assetId,
              infoListItems: [
                {
                  name: 'trackingId',
                  label: 'Tracking Id',
                },
                {
                  name: 'installer',
                  label: 'installer',
                },
                {
                  name: 'assetId',
                  label: 'Asset Tag',
                },
                {
                  name: 'type',
                  label: 'Type',
                },
                {
                  name: 'owner',
                  label: 'Owner',
                },
              ]
            }
          ]
        },
        {
          type: FormItemType.tab,
          items: [
            {
              label: "Sensors",
              items: [
                {
                  type: FormItemType.customComponent,
                  component: ElectronicsSensorTab
                }
              ]
            }
          ]
        }
      ]
    }
  ]

} as FormView;



export const ElectronicsEditComponent = initView({ form: electronicsEdit, dataSource: electronicsDs })

